import {BasicPaging} from '../../../../../components/paging/basic/basic-paging'
import {SpacingBlank} from '../../../../../components/paging/basic/styling/spacing-blank.styled'
import {useDimensions} from '../../../../../contexts/dimensions/use-dimensions'
import {usePagedReports} from '../../../contexts/use-paged-reports'
import {getPagesToShow, getPagingButtonsToShow} from './paging-helpers'

export function Pagination(): JSX.Element {
    const {selectedPage, totalNumberOfPages, selectPage, pageSize} = usePagedReports()

    const {width} = useDimensions()

    if (
        selectPage == null ||
        selectedPage == undefined ||
        totalNumberOfPages == undefined ||
        pageSize == undefined
    ) {
        return <SpacingBlank />
    }

    return (
        <BasicPaging
            gtmEventPrefix="reports"
            selectedPage={selectedPage}
            totalNumberOfPages={totalNumberOfPages}
            selectPage={selectPage}
            pagesToShow={getPagesToShow(width)}
            pageSize={pageSize}
            showButtons={getPagingButtonsToShow(width, totalNumberOfPages)}
        />
    )
}
